import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { Ripple } from "primereact/ripple";
import { Nav } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { TitleContext } from "../../../../Context/TitleContext";
import { API_URL, useAxios, rowsPerPageOptions } from "../../../../utils/const";
import { Toaster } from "react-hot-toast";
import { DeleteModal } from "./DeleteModal";
import CreateModal from "./CreateModal";
import { useToast } from "../../../../Context/ToastContext";

const CourseLecturerDetail = () => {

  const { setTitle } = useContext(TitleContext);
  const { setToastObj } = useToast();
  const axiosInstance = useAxios();
  const { id } = useParams();

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [course, setCourse] = useState();

  const [courseGroupLecturers, setCourseGroupLecturers] = useState([]);
  const [courseGroupLecturerRecords, setCourseGroupLecturerRecords] = useState(
    []
  );
  const [selectedCourseGroupLecturer, setSelectedCourseGroupLecturer] =
    useState([]);

  const [lecturers, setLecturers] = useState([]);
  const [key, setKey] = useState("");
  const [isRendered, setIsRendered] = useState(false);

  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({ first: 0, rows: 10, page: 0 });
  const [loadingInfoBasic, setLoadingInfoBasic] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTitle("USAKTI | Reg. Modul Dosen"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingInfoBasic(true);
        await getCourseById(id);
        await getLecturers();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoadingInfoBasic(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (isRendered) {
        try {
          setLoading(true);
          await getCourseLecturersByGroupId();
        } catch (error) {
          setToastObj({
            msg: error,
            type: "danger",
          });
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [pagination, key]);

  const toggleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };

  const toggleOpenDeleteModal = (e) => {
    setSelectedCourseGroupLecturer(e);
    setOpenDeleteModal(true);
  };

  const getCourseById = async (id) => {
    const response = await axiosInstance.get(`${API_URL}/courses/${id}`);
    setCourse(response.data.data);
  };

  const getCourseLecturersByGroupId = async () => {
    const courseGroupLecturersTemp = {};
    const limit = pagination.rows === "All" ? -1 : pagination.rows;

    for (const item of course.courseGroups) {
      const response = await axiosInstance.get(
        `${API_URL}/course-lecturers/find-by/group-id/${item.id
        }?search${search}=&page=${pagination.page + 1}&limit=${limit}`
      );

      courseGroupLecturersTemp[item.group.name] = {
        courseGroupLecturers: response.data.data.courseGroupLecturers,
        totalRecords: response.data.data.totalRecords,
      };
    }

    setCourseGroupLecturers(courseGroupLecturersTemp);
    setCourseGroupLecturerRecords(courseGroupLecturersTemp[`${key}`]);
  };

  const getLecturers = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-lecturers/find-unregistered-by-course-id/${id}`
    );
    setLecturers({ lecturers: response.data.data });
  };

  function handleFilter(courseGroup, event) {
    const newData = courseGroupLecturers[
      `${courseGroup}`
    ].courseGroupLecturers.filter((row) => {
      return (
        row.lecturer.nim
          .toLowerCase()
          .includes(event.target.value.toLowerCase()) ||
        row.lecturer.name
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      );
    });

    const courseGroupLecturersTemp = {
      courseGroupLecturers: newData,
      totalRecords: courseGroupLecturers[`${courseGroup}`].totalRecords,
    };

    setCourseGroupLecturerRecords(courseGroupLecturersTemp);
    setSearch(event.target.value);
  }

  function handleTabChange(courseGroup) {
    setIsRendered(true);
    setKey(courseGroup);
    setPagination({ first: 0, rows: pagination.rows, page: 0 });
  }

  function handleRowChange(row) {
    setPagination({ first: 0, rows: row, page: 0 });
  }

  const paginationTemplate = {
    layout: "PrevPageLink PageLinks NextPageLink ",
    PrevPageLink: (options) => {
      return (
        <button type="button" className="btn border">
          <span className="p-3">Previous</span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button type="button" className="btn border">
          <span className="p-3">Next</span>
          <Ripple />
        </button>
      );
    },
  };

  const onPageChange = async (event) => {
    setPagination({ first: event.first, rows: event.rows, page: event.page });
  };

  return loadingInfoBasic == false ? (
    <div>
      <Toaster position="top-right" />
      <div className="container-fluid">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Dosen Terdaftar</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link>Registrasi Modul Dosen</Link>
              </li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            <div
              className="row justify-content-between"
              style={{ margin: "20px 0" }}
            >
              <div className="col-md-12 text-start table-responsive">
                <table style={{ width: "650px" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "175px" }}>Kode MK</td>
                      <td>: {course.kode_mk}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Modul</td>
                      <td>: {course.name}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Semester</td>
                      <td>: {course.semester.name}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "175px" }}>Kelompok Modul</td>
                      <td>
                        :{" "}
                        {course.courseGroups.length > 0
                          ? course.courseGroups
                            .map((item) => item.group.name)
                            .join(", ")
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold" style={{ width: "175px" }}>
                        Total Peserta
                      </td>
                      <td className="fw-bold">
                        :{" "}
                        {course.courseTotalParticipants.length > 0
                          ? course.courseTotalParticipants[0].total_participants
                          : 0}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 justify-content-end d-flex gap-1">
                <button
                  className="btn btn-success"
                  onClick={toggleOpenCreateModal}
                >
                  + Tambah
                </button>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 text-center offset-md-4">
                <h4>{`Kelompok ${key}`}</h4>
              </div>
            </div>

            <div className="row">
              <Tab.Container
                activeKey={key}
                onSelect={(k) => handleTabChange(k)}
              >
                <Nav variant="pills" className="mb-3">
                  {course.courseGroups.map((item) => (
                    <Nav.Item>
                      <Nav.Link eventKey={item.group.name}>
                        Kelompok {item.group.name}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>

                {/* TAB CONTENT */}
                {loading == false ? (
                  <Tab.Content>
                    {course.courseGroups.map((item) => (
                      <Tab.Pane eventKey={item.group.name}>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label>Show</label>
                            <select
                              value={pagination.rows}
                              onChange={(e) => handleRowChange(e.target.value)}
                              className="form-select form-select-sm d-inline-block w-auto ms-2"
                            >
                              {rowsPerPageOptions.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                            <label style={{ marginLeft: "5px" }}>entries</label>
                          </div>
                          <div className="col-md-6 text-end">
                            <label>Search :</label>
                            <input
                              type="text"
                              style={{
                                width: "auto",
                                display: "inline-block",
                                marginLeft: "5px",
                              }}
                              className="form-control form-control-sm"
                              onChange={(event) =>
                                handleFilter(item.group.name, event)
                              }
                            />
                          </div>
                        </div>

                        <div className="table-responsive">
                          {/* Tabel Data Dosen */}
                          <table className="table table-striped mt-3">
                            <thead>
                              <tr>
                                <th>NO</th>
                                <th>NIDN</th>
                                <th>NAMA</th>
                                <th className="text-center">AKSI</th>
                              </tr>
                            </thead>
                            <tbody>
                              {courseGroupLecturerRecords.courseGroupLecturers !==
                                undefined &&
                                courseGroupLecturerRecords.courseGroupLecturers.map(
                                  (
                                    courseGroupLecturer,
                                    courseGroupLecturerIndex
                                  ) => (
                                    <tr key={courseGroupLecturerIndex}>
                                      <td>
                                        {pagination.first +
                                          courseGroupLecturerIndex +
                                          1}
                                      </td>
                                      <td>
                                        {courseGroupLecturer.lecturer.nim}
                                      </td>
                                      <td>
                                        {courseGroupLecturer.lecturer.name}
                                      </td>
                                      <td className="text-center">
                                        <button
                                          className="btn btn-danger text-white btn-sm"
                                          onClick={() =>
                                            toggleOpenDeleteModal(
                                              courseGroupLecturer
                                            )
                                          }
                                        >
                                          <i className="fas fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </table>
                        </div>

                        {/* Paginator dari PrimeReact */}
                        <div className="row">
                          <div className="col-md-6 d-flex align-items-center h-100">
                            <p>
                              Showing {pagination.first + 1} to{" "}
                              {pagination.rows >
                                courseGroupLecturerRecords.totalRecords
                                ? courseGroupLecturerRecords.totalRecords
                                : pagination.rows}{" "}
                              of {courseGroupLecturerRecords.totalRecords}{" "}
                              entries
                            </p>
                          </div>
                          <div className="col-md-6">
                            <Paginator
                              first={pagination.first}
                              rows={pagination.rows === "All" ? courseGroupLecturerRecords.totalRecords : pagination.rows}
                              totalRecords={courseGroupLecturerRecords.totalRecords}
                              onPageChange={onPageChange}
                              template={paginationTemplate}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                ) : (
                  <></>
                )}
              </Tab.Container>
            </div>
          </div>
        </div>
        {openCreateModal && (
          <CreateModal
            toggleModal={setOpenCreateModal}
            id={id}
            getCourseById={getCourseById}
            getCourseLecturersByGroupId={getCourseLecturersByGroupId}
            getLecturers={getLecturers}
            lecturers={lecturers}
            courseGroups={course.courseGroups}
          />
        )}
        {openDeleteModal && (
          <DeleteModal
            toggleModal={setOpenDeleteModal}
            id={id}
            getCourseById={getCourseById}
            getCourseLecturersByGroupId={getCourseLecturersByGroupId}
            getLecturers={getLecturers}
            courseGroupLecturer={selectedCourseGroupLecturer}
          />
        )}
      </div>
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default CourseLecturerDetail;
